/**
 * The toasts the order surfaces owe the user about an order the venue
 * answered, shared by the ticket's button, the pro ladder, the book's click to
 * trade and the ticket's one-tap presets.
 *
 * A module of its own so the ticket, which is on the cold load, can use them
 * without carrying the ladders' trading hook (invariant 19).
 */

import { presentError } from '@/domain/order-errors'
import { pushToast } from '@/stores/ui'

/**
 * Say so when the venue's self-trade prevention cancelled an order, and
 * whether it did.
 *
 * An order whose price reaches the account's own resting order on the other
 * side — a bid at or above its own ask — is cancelled whole by the venue's STP
 * (`CANCEL_NEWEST`, `docs/04` §7.10): nothing fills, not even against other
 * traders' orders ahead of the account's own. The catalogue marks `SELF_MATCH`
 * quiet — never a red failure, because it is the venue's rule and not the
 * user's mistake — so it is an **info** toast in the catalogue's own words, on
 * every surface (spec owner, 2026-10-16); without it the order would simply
 * vanish, with nothing on screen saying why.
 *
 * `true` when it announced: the caller stops there, because the second leg of
 * a split sell is the same ask at the same price and would be cancelled too.
 */
export function announceSelfMatch(order: unknown): boolean {
  if ((order as Record<string, unknown> | null | undefined)?.reason !== 'SELF_MATCH') return false
  const copy = presentError({ code: 'SELF_MATCH' })
  pushToast({ tone: 'info', title: copy.title, body: copy.body })
  return true
}

